import React from "react";
import { motion } from "framer-motion";
import { Gift, ArrowUpRight } from "lucide-react";

export default function PromoCard({ title, subtitle, color, path }) {
  const handleClick = () => {
    // Navigate to the path when clicked
    if (path) {
      window.location.href = path;
      // If using Next.js: router.push(path)
      // If using React Router: navigate(path)
    }
  };

  return (
    <motion.div
      className={`${color} rounded-lg p-3 min-w-[150px] shadow-lg cursor-pointer`}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      onClick={handleClick}
    >
      <div className="flex items-start mb-2">
        <Gift className="w-5 h-5 text-yellow-400" />
      </div>
      <h3 className="text-white font-medium text-sm">{title}</h3>
      <p className="text-blue-200 text-xs">{subtitle}</p>
      <div className="flex items-center mt-2">
        <span className="text-white text-xs font-medium">Ver más</span>
        <ArrowUpRight className="w-3 h-3 text-white ml-1" />
      </div>
    </motion.div>
  );
}
